export default import.meta.ROLLDOWN_FILE_URL_pzoK2cUqYKhSfdVSi6cA_A